import {checkError, closeAlert, receiveErrorAlert, receiveSuccessAlert} from "../commonsActions";
import {
    confirmLoan,
    getLoanOrder,
    getLoanOrders,
    rejectLoan,
    returnProduct,
    saveLoanOrder
} from "../../helpers/loanOrderService";

export const FETCH_LOAN_ORDER_LIST_BEGIN = 'FETCH_LOAN_ORDER_LIST_BEGIN';
export const FETCH_LOAN_ORDER_LIST_SUCCESS = 'FETCH_LOAN_ORDER_LIST_SUCCESS';
export const FETCH_LOAN_ORDER_LIST_ERROR = 'FETCH_LOAN_ORDER_LIST_ERROR';

export const FETCH_LOAN_ORDER_BEGIN = 'FETCH_LOAN_ORDER_BEGIN';
export const FETCH_LOAN_ORDER_SUCCESS = 'FETCH_LOAN_ORDER_SUCCESS';
export const FETCH_LOAN_ORDER_ERROR = 'FETCH_LOAN_ORDER_ERROR';

export const UPDATE_LOAN_ORDER_BEGIN = 'UPDATE_LOAN_ORDER_BEGIN';
export const UPDATE_LOAN_ORDER_SUCCESS = 'UPDATE_LOAN_ORDER_SUCCESS';
export const UPDATE_LOAN_ORDER_ERROR = 'UPDATE_LOAN_ORDER_ERROR';

/*
 * action creators
 */

const fetchLoanOrderListSuccess = res => ({
    type: FETCH_LOAN_ORDER_LIST_SUCCESS,
    payload: {
        loanOrderList: res.data,
        numberOfElements: res.numberOfElements,
        totalElements: res.totalElements,
        totalPages: res.totalPages
    }
});

const fetchLoanOrderListError = error => ({
    type: FETCH_LOAN_ORDER_LIST_ERROR,
    payload: {
        error: error,
    }
});

export const fetchLoanOrderList = (query, lang) => dispatch => {
    dispatch({type: FETCH_LOAN_ORDER_LIST_BEGIN});

    return getLoanOrders(query, lang).then(res => {
        dispatch(fetchLoanOrderListSuccess(res));
        return res;
    }, error => {
        dispatch(fetchLoanOrderListError(error))
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    });
};

export const fetchLoanOrder = (orderId, lang) => dispatch => {
    dispatch({type: FETCH_LOAN_ORDER_BEGIN});

    return getLoanOrder(orderId, lang).then(res => {
        dispatch({
            type: FETCH_LOAN_ORDER_SUCCESS,
            loanOrder: res,
        });
        return res;
    }, error => {
        dispatch({
            type: FETCH_LOAN_ORDER_ERROR,
            error: error,
        })
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    });
}

export const createLoanOrder = (order, lang) => dispatch => {
    return saveLoanOrder(order, lang).then(res => {
        dispatch(receiveSuccessAlert('Success'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    });
};

export const rejectLoanOrder = (orderId, lang) => dispatch => {
    dispatch({type: UPDATE_LOAN_ORDER_BEGIN});

    return rejectLoan(orderId, lang).then(res => {
        dispatch({
            type: UPDATE_LOAN_ORDER_SUCCESS,
            loanOrder: res,
        });
        dispatch(receiveSuccessAlert('Success'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    }, error => {
        dispatch({
            type: UPDATE_LOAN_ORDER_ERROR,
            error: error,
        })
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return error;
    });
};

export const confirmLoanOrder = (orderId, lang) => dispatch => {
    dispatch({type: UPDATE_LOAN_ORDER_BEGIN});

    return confirmLoan(orderId, lang).then(res => {
        dispatch({
            type: UPDATE_LOAN_ORDER_SUCCESS,
            loanOrder: res,
        });
        dispatch(receiveSuccessAlert('Success'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    }, error => {
        dispatch({
            type: UPDATE_LOAN_ORDER_ERROR,
            error: error,
        })
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return error;
    });
};

export const returnLoanOrderProduct = (orderId, lang, returnRequest) => dispatch => {
    dispatch({type: UPDATE_LOAN_ORDER_BEGIN});

    return returnProduct(orderId, lang, returnRequest).then(res => {
        dispatch({
            type: UPDATE_LOAN_ORDER_SUCCESS,
            loanOrder: res,
        });
        dispatch(receiveSuccessAlert('Success'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    }, error => {
        dispatch({
            type: UPDATE_LOAN_ORDER_ERROR,
            error: error,
        })
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        throw error;
    });
};


// WEBPACK FOOTER //
// ./src/actions/loan/loanOrderActions.js